import { create } from 'zustand';

export const useUIStore = create((set, get) => ({
  // Sidebar
  sidebarOpen: true,
  setSidebarOpen: (open) => set({ sidebarOpen: open }),
  toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),

  // Theme
  theme: 'light',
  setTheme: (theme) => set({ theme }),
  toggleTheme: () => set((state) => ({ theme: state.theme === 'light' ? 'dark' : 'light' })),

  // Modals
  modals: {},
  openModal: (modalId) => 
    set((state) => ({ 
      modals: { ...state.modals, [modalId]: true } 
    })),
  closeModal: (modalId) => 
    set((state) => ({ 
      modals: { ...state.modals, [modalId]: false } 
    })),
  closeAllModals: () => set({ modals: {} }),

  // Notifications
  notifications: [],
  addNotification: (notification) => {
    const id = Math.random().toString(36).substr(2, 9);
    const newNotification = { ...notification, id };
    
    console.log('Adding notification:', newNotification);
    
    set((state) => ({
      notifications: [...state.notifications, newNotification]
    }));
  },
  removeNotification: (id) => 
    set((state) => ({
      notifications: state.notifications.filter(n => n.id !== id)
    })),
  clearNotifications: () => set({ notifications: [] }),

  // Loading states
  loadingStates: {},
  setLoading: (key, loading) => 
    set((state) => ({
      loadingStates: { ...state.loadingStates, [key]: loading }
    })),
  isLoading: (key) => get().loadingStates[key] || false,

  // Filters
  filters: {},
  setFilter: (key, value) => 
    set((state) => ({
      filters: { ...state.filters, [key]: value }
    })),
  clearFilters: () => set({ filters: {} }),
  getFilter: (key) => get().filters[key],
}));

